import React 			from 'react';
import ReactDOM 		from 'react-dom';
import moment 			from 'moment';

import BLComponent		from '../../../core/_BLComponent.jsx';

import BDPSubmissionCard from '../_BDPSubmissionCard.jsx';
import {bdpDateFormatLong} from '../_BDPUtilities.jsx';

import BDPVideoGalleryBlock from '../_BDPVideoGalleryBlock.jsx';

import CrowdfundingCountdown 	from '../_CrowdfundingCountdown.jsx';
import StudioActivityContent from '../../../studio/_StudioActivityContent.jsx';

export default class CrowdfundingActiveEnded extends BLComponent {
	constructor (props, context) {
		super(props, context);

		this.state = {
		};
	}

	render() {
		const {isLanding = false, activitySlug, showActivity, seriesContent, finalists, crowdData} = this.props;

		const activeSeriesData = crowdData.filter(item => finalists.map(finalist => finalist.idSubmission).indexOf(item.idSubmission) != -1);
		const isAllSoldOut = activeSeriesData.filter(finalist => finalist.stock.bSoldOut || finalist.stock.dPercentagePreordered >= 1).length == finalists.length;
		const isEnded = blapp.config.server_time >= seriesContent.udtCrowdFundingEnd;

		const finalistCards = finalists.map(submission => <BDPSubmissionCard hidePurchase={isAllSoldOut || isEnded} data={submission} salesInfo={crowdData.filter(item => item.idSubmission == submission.idSubmission)[0]} key={submission.idSubmission} hasVoting={false} hasPricing={!isAllSoldOut && !isEnded} classes="bdp-series-submissions__card"/>);

		return (
			<section className="bdp-series-past__finalists">
				{this.renderHeader()}
				{(isAllSoldOut || isEnded) && this.renderNextSteps()}
				<section className="bdp-series-submissions__card-container bdp-series-submissions__card-container--finalists-landing">
					{finalistCards}
				</section>
				{isLanding ? <a href={blapp.url2.getCrowdSeriesUrl(seriesContent.strSlug)} className="btn bg-color--white text-color--darkestBlue text--small-title text--bold bdp-series-main__announcement-link">Go to {seriesContent.strName}<i className="fas fa-long-arrow-right l-margin-left"/></a> : null}
				<BDPVideoGalleryBlock finalists={finalists} seriesContent={seriesContent}/>
				{showActivity ? this.renderActivity(activitySlug) : null}
			</section>
		);
	}

	renderHeader() {
		const {isLanding = false, seriesContent, finalists, crowdData} = this.props;

		const activeSeriesData = crowdData.filter(item => finalists.map(finalist => finalist.idSubmission).indexOf(item.idSubmission) != -1);
		const isAllSoldOut = activeSeriesData.filter(finalist => finalist.stock.bSoldOut || finalist.stock.dPercentagePreordered >= 1).length == finalists.length;
		const isEnded = blapp.config.server_time > seriesContent.udtCrowdFundingEnd;

		if(isEnded) {
			return (
				<div className="bdp-series-main__pre-crowd-header l-start">
					<div className="bdp-series-main__pre-crowd-title">
						{isLanding && <h1 className="bdp-series-main__announcement-sub bdp-series-main__announcement-sub--finalists-landing bdp-series-main__announcement-sub--pre-crowd text--uppercase">{seriesContent.strName}</h1>}
						<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">{seriesContent.strName} Crowdfunding is now over</h2>
						<p className="bdp-series-main__announcement-intro bdp-series-main__announcement-intro--finalists-landing">Thank you for your support!</p>
					</div>
				</div>
			);
		}else if(isAllSoldOut) {
			return (
				<div className="bdp-series-main__pre-crowd-header l-start">
					<div className="bdp-series-main__pre-crowd-title">
						{isLanding && <h1 className="bdp-series-main__announcement-sub bdp-series-main__announcement-sub--finalists-landing bdp-series-main__announcement-sub--pre-crowd text--uppercase">{seriesContent.strName}</h1>}
						<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">{seriesContent.strName} sold out early!</h2>
						<p className="bdp-series-main__announcement-intro bdp-series-main__announcement-intro--finalists-landing">Thank you for your support.</p>
					</div>
				</div>
			);
		}else{
			return (
				<div className="bdp-series-main__pre-crowd-header l-start">
					<div className="bdp-series-main__pre-crowd-title">
						{isLanding && <h1 className="bdp-series-main__announcement-sub bdp-series-main__announcement-sub--finalists-landing bdp-series-main__announcement-sub--pre-crowd text--uppercase">{seriesContent.strName}</h1>}
						<h2 className="bdp-series-main__announcement-title l-margin-bottom--sm">Order your favorite {seriesContent.strName} sets!</h2>
						<p className="bdp-series-main__announcement-intro bdp-series-main__announcement-intro--finalists-landing">Pre-ordering ends on {bdpDateFormatLong(seriesContent.udtCrowdFundingEnd)} Pacific time, or once all sets sell out.</p>
					</div>
					<div className="bdp-series-main__pre-crowd-clock-container text--center">
						<h2 className="text--bold l-margin-bottom--sm text--title">Crowdfunding ends in</h2>
						<CrowdfundingCountdown classes="bdp-series-main__clock bdp-series-main__clock--dark l-margin-bottom--null" end={seriesContent.udtCrowdFundingEnd}/>
					</div>
				</div>
			);
		}
	}

	renderActivity(slug) {
		const seriesContent = this.props.seriesContent;
		const crossPromoContent = {strActivityIntroBlurb: seriesContent.strActivityIntroBlurb, strActivityWinnersText: seriesContent.strActivityWinnersText, strActivityWinnersTitle: seriesContent.strActivityWinnersTitle}

		return (
			<section className="bdp-series-main__cross-promotion">
				<StudioActivityContent slug={slug} activity={seriesContent.dmActivity} crossPromotion={crossPromoContent}/>
			</section>
		);
	}

	renderNextSteps() {
		const gridClass = 'mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-desktop-l mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-8-phone';
	
		return (
			<section className="mdc-layout-grid l-pad--null bdp-series-main__crowd-ended">
				<div className="mdc-layout-grid__inner">
					<article className={`bg-color--white l-border-round l-pad--xl l-shadow bdp-model__whats-next-item bdp-series-main__timeline-item--red bdp-series-main__timeline-item--sidebar ${gridClass}`}>
						<div className="bdp-series-main__timeline-icon bdp-model__sidebar-countdown-icon bdp-series-main__crowd-ended-item-icon--red">
							<i className="far fa-truck-fast fa-fw"/>
						</div>
						<div>
							<h3 className="text--title text--bold">When will my order ship?</h3>
							<p className="text--small-title">It will take approximately 6 months from the time you pre-ordered to receive your set. <a href={blapp.url2.getCrowdProjectFAQUrl() + '#how-long-will-it-take-from-when-i-place-my-order-to-when-my-set-is-shipped-and-i-receive-it'}>Read more</a></p>
						</div>
					</article>
					<article className={`bg-color--white l-border-round l-pad--xl l-shadow bdp-model__whats-next-item bdp-series-main__timeline-item--green bdp-series-main__timeline-item--sidebar ${gridClass}`}>
						<div className="bdp-series-main__timeline-icon bdp-model__sidebar-countdown-icon bdp-series-main__crowd-ended-item-icon--green">
							<i className="far fa-credit-card fa-fw"/>
						</div>
						<div>
							<h3 className="text--title text--bold">When will I be charged?</h3>
							<p className="text--small-title">If you paid with a credit card, you will only be charged once the item ships. <a href={blapp.url2.getCrowdProjectFAQUrl() + '#when-will-i-be-charged-how-can-i-make-sure-my-order-goes-through-smoothly-without-any-problems?'}>Read more</a></p>
						</div>
					</article>
				</div>
			</section>
		);
	}
}